function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-012c7364\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"quietDeps\":true,\"silenceDeprecations\":[\"legacy-js-api\",\"import\"],\"sourceMap\":true}!./UnboxAPIResponseLog.scss")
}
var normalizeComponent = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!./UnboxAPIResponseLog.js"/* template */
import __vue_template__ from "!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-012c7364\",\"hasScoped\":true}!./UnboxAPIResponseLog.html"
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-012c7364"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/components/UnboxSurat/UnboxAPIResponseLog/index.vue
// module id = 1454
// module chunks = 2